import styled from 'styled-components';
import breakpoint from 'components/utils/responsive';
import { colorToken } from "components/utils/constants";

export default styled.div`
    min-height: 100vh;
    display: flex;
    padding-top: 95px;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    background-image: url('/assets/img/bg-interna.jpg');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    
    img {
        max-width: 100%;
    }
    @media ${breakpoint.md} {
        padding-top: 100px;
        /* flex-basis: 50%;
        flex-direction: row; */
    }
`;

export const StyleContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    transition: max-height linear 0.2s;
    align-items: center;
    width: 100%;
    flex-grow: 1;
        
    justify-content: space-between;
    > div:last-of-type {
        text-align: center;
         padding-bottom: 12px;
    }
    p{
        color: ${colorToken.white};
        text-align: center;
        padding: 0 16px;
    }
    @media ${breakpoint.md} {
        /* flex-basis: 50%;
        flex-direction: row; */
        p{
            width: 65%;
            margin: 0 auto;
           
        }
    }

`;

export const StyleFlexPrizes = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    flex-grow: 1;
    justify-content: space-between;
    margin: 0 auto;
    max-width: 1268px;
    flex-direction: column;
    padding: 24px;
    p {
        margin: 24px auto;
    }
    > div:first-of-type {
        margin-bottom: 32px;
    }
    @media ${breakpoint.md} {
        flex-direction: row;
        p {
            width: 65%;
            margin: 24px auto;
        }
    }
`;